import React from 'react';
import {IBSPlank, IOption} from "./interfaces";
import {CityItem} from "./cityItem";
import {BSItem} from "./bsItem";
import {get_bs_address} from "../../utils/misc";

export class OptionModel {
  value?: number;
  label?: JSX.Element | string;
  defaultLabel?: string;
  type?: 'city' | 'blood_station';
  slug?: string;

  constructor(option: IOption) {
    this.value = option?.id;
    this.label = OptionModel.getLabelFromType(option);
    this.defaultLabel = option?.title;
    this.type = option?.type;
    this.slug = option?.slug;
  }

  private static getLabelFromType(option: IOption) {
    if (option) {
      if (option?.type === 'city')
        return <CityItem address={option.address} title={option.title} slug={option.slug}/>
      if (option?.type === 'blood_station')
        return <BSItem address={option.address} title={option.title} id={option.id}/>
      else return option?.title
    } else return ''
  }
}

export class BSPlankModel {
  id?: number;
  cityId?: number;
  title?: string;
  address?: string;
  isWanted?: boolean;
  lat?: number;
  lng?: number;

  constructor(BSPlank: IBSPlank, fromStore: boolean) {
    this.id = BSPlank?.id;
    this.cityId = BSPlank?.city_id;
    this.title = BSPlank?.title;
    this.address = fromStore ? get_bs_address(BSPlank) : BSPlank?.address;
    this.isWanted = !!BSPlank?.is_wanted;
    this.lat = BSPlank?.lat;
    this.lng = BSPlank?.lng;
  }
}
